export const getProduct = (data) => {
  return data.map((item)=>{
    return item.name;
  }).join('、');
};
// to使用
export const getCompany = (data, id) => {
  return data.find((value) => {
    return id === value.id;
  }).companyInfo.qichacha_name;
};
